module.exports = __webpack_public_path__ + "static/img/image_6.ecb3d071.png";